import React from 'react';
import BadgeImg from './images/review-completed.png';
import './reviewCompleteBadge.module.scss';
import { LazyImage } from '../../../../commonv3/components/atoms/images/LazyImage';

export const ReviewCompleteBadge = () => (
  <LazyImage offset={100} src={BadgeImg} styleName="review-complete-badge" className="review-complete-badge" />
);
